<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">장애처리기술료관리</h2>
        </div>
      </el-form>
      <!--      -->
      <div class="search-form" style=" width: 30%; border: unset; background: unset;">
        <el-form size="mini">
          <el-row style="margin-bottom: 10px;">
            <el-col>
              <el-form-item label="기준일자">
                <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 테이블 -->
      <div class="talbe-contain" style="display: flex;">
        <div class="table-area" style="margin-right: 50px; width: 30%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridMain"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :headerHeight="0"
                :rowModelType="rowModelType"
                :treeData="true"
                :isServerSideGroup="isServerSideGroup"
                :isServerSideGroupOpenByDefault="isServerSideGroupOpenByDefault"
                :getServerSideGroupKey="getServerSideGroupKey"
                :autoGroupColumnDef="autoGroupColumnDef"
                :animateRows="true"
                :rowData="data"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :gridOptions="gridOptions"
                :suppressRowClickSelection="false"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClickedMain"
            />
          </div>
        </div>
        <div class="table-area" style="width: 70%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 42vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySub"
                @cell-clicked="onCellClickedSub"
            />
          </div>

          <div class="table-b" style="margin-bottom: 0px;">
            <div class="table-header">
              <div class="table-name">
                <h3 class="ico_table_name">기술료 적용이력</h3>
              </div>
              <el-form style="display: grid; float: right;" size="small">
                <el-form-item label-width="0px" style="float: right;">
                  <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
                  <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
                </el-form-item>
              </el-form>
            </div>
            <ag-grid-vue
                ref="gridDetail"
                style="width: 100%; height: 28vh; min-height: 25px;"
                class="ag-theme-alpine"
                rowSelection="multiple"


                :columnDefs="columnDefsDetail"
                :defaultColDef="defaultColDefDetail"
                :frameworkComponents="frameworkComponents"
                :rowData="detailData"
                :gridOptions="gridOptionsDetail"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySubDetail"
            />
          </div>

          <obstacleInfo ref="obstacleInfo"  :catDetail="catDetail"/>
        </div>
      </div> <!-- table contain -->
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import obstacleInfo from '@/components/InfoManage/ObstacleInfo/ObstacleInfo.vue';
import AgGridSearchBtn from "@/components/agGrid/AgGridSearchBtn";
import MakerModal from "@/components/InfoManage/ObstacleInfo/MakerModal";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";



/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "obstacleTreatMng",
  components: {obstacleInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      rowData: [],
      subRowData: [],
      componentKey: 0,
      form: {
        catId:"",
        catIdx:"",
        catKey:"",
        catLvl:"",
        catNm:"",
        catPath:"",
        catValue1:"",
        catValue2:"",
        catValue3:"",
        catValue4:"",
        catValue5:"",
        companyId:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        endDt:"",
        keyPath:"",
        parentId:"",
        repairCatId:"",
        repairFee1:"",
        repairFee2:"",
        repairFee3:"",
        repairFee4:"",
        repairFee5:"",
        repairFee6:"",
        repairFee7:"",
        repairFee8:"",
        repairFee9:"",
        repairFee10:"",
        repairFeeId:"",
        sortPath:"",
        startDt:this.$moment().format('YYYY-MM-DD'),
        topKey:"RepairCat",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        useYn: "Y",
      },
      defForm: {
        catId:"",
        catIdx:"",
        catKey:"",
        catLvl:"",
        catNm:"",
        catPath:"",
        catValue1:"",
        catValue2:"",
        catValue3:"",
        catValue4:"",
        catValue5:"",
        companyId:"",
        createDt: this.$moment(new Date()).format('YYYY-MM-DD'),
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        endDt:"",
        keyPath:"",
        parentId:"",
        repairCatId:"",
        repairFee1:"",
        repairFee2:"",
        repairFee3:0,
        repairFee4:0,
        repairFee5:0,
        repairFee6:0,
        repairFee7:0,
        repairFee8:0,
        repairFee9:0,
        repairFee10:0,
        repairFeeId:"",
        sortPath:"",
        startDt:this.$moment(new Date()).format('YYYY-MM-DD'),
        topKey:"RepairCat",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        useYn: "Y",
      },
      data: [],
      subData: [],
      detailData: [],
      tempData: [],
      makerData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsDetail: {

      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      defaultColDefDetail: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      catDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      gridApiDetail: null,
      columnApiDetail: null,
      columnDefsSub: [],
      columnDefsDetail: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      gridStyle : 'padding-top: 0px; width: 100%;height: 80vh; min-height:100px;',
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      
      const updateData = (data) => {
        var fakeServer = this.createFakeServer(data);
        var datasource = this.createServerSideDatasource(fakeServer);
        params.api.setServerSideDatasource(datasource);
        return data;
      };
      this.$http.post(_url("/api/tree/obstacleTreatMng/list"), {
        companyId: this.$store.state.loginInfo.compCd,
        processTime : ""
      }).then(response => {
        this.data = updateData(response.data);
      })
      .finally(_ => {
        this.gridApi.sizeColumnsToFit();
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    onReadySubDetail(params) {
      //디테일그리드 api 정의
      this.gridApiDetail = this.gridOptionsDetail.api;
      this.columnApiDetail = this.gridOptionsDetail.columnApi;

      this.gridApiDetail.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indicate if node is a group
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {headerName:'제품군', field:'catNm2', editable:false},
        {headerName:'증상구분', field:'catNm3', editable:false},
        {headerName:'고장증상', field:'catNm4', editable:false},
        {headerName:'고장부위', field:'catNm5', editable:false},
        {headerName:'처리유형', field:'catNm6', editable:false},
        {headerName:'내근', field:'repairFee1', editable:false,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          },
        },
        {headerName:'외근', field:'repairFee2', editable:false,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          },
        },
        {headerName: '적용일자', field: 'startDt', editable: true, cellStyle: {textAlign: 'right'},valueFormatter: (params) => {return vm.getDateFormat(`${params.value}`);}},
        {headerName:'', field:'catId', hide : true},];

      this.columnDefsDetail = [
        {headerName:'적용일자', field:'startDt', resizable: true , width:50, editable:true,
          cellStyle:{textAlign: 'center'},
          cellRenderer: 'datePicker'
        },
        {headerName:'내근', field:'repairFee1', resizable: true , width:50, editable:true,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          },
        },
        {headerName:'외근', field:'repairFee2', resizable: true , width:50, editable:true,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          },
        },
        {headerName:'적용제조사', field:'makerStr', resizable: true , width:50, editable:false,
          cellRenderer: 'schBtn',
          cellStyle: { 'padding-left': '3px', 'padding-right': '0px'},
          cellRendererParams(params) {
            return {
              funcNm: 'updateMakerItem',
              value: vm.makerStr(params.data.makerArr)
            }
          }
        },
        {
          headerName: '', field: 'makerBtn', resizable: true , width: 10, editable: true,
          cellRenderer: 'buttonCellRenderer',
          cellRendererParams: {
            name: '수정',
            onClick: 'updateItem',
          }
        }
        // },
      ]
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {
      this.cancel();
      const voRow = params.data //선택된 Row
      this.rowData = params.data
      this.catDetail = this.defForm;
      this.parentNm = voRow.menu_nm;
      this.$store.commit('loading')
      this.$http
          .post("/api/obstacleTreatMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow.menu_id,
            standDt : this.form.startDt,
            catNm4: "",
            catNm5: "",
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.detailData = [];
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClickedSub(params) {
      this.cancel();
      const voRow = params.data//선택된
      this.subRowData = params.data;
      this.$store.commit('loading')
      this.$http
          .post("/api/obstacleTreatMng/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            catId: voRow.catId,
            sortType : true,
            processTime : ""
          })
          .then(response => {
              // this.detailData = response.data
              this.catDetail = voRow;
              this.$refs.obstacleInfo.form.catId = voRow.catId;


              this.tempData = response.data
              let submitList = [];
              response.data.forEach(x=>{
                submitList.push({
                  companyId: this.$store.state.loginInfo.compCd,
                  repairFeeId: x.repairFeeId
                })
              });
              
              this.$http.post("/api/obstacleTreatMng/detail/sub/maker",submitList).then(response =>{

                  this.makerData = response.data;
                  this.makerData.forEach(x=>{
                    if(x[0] !== undefined){
                      x.repairFeeId = x[0].repairFeeId;
                    }
                  })
                  this.tempData.forEach(x=>{
                    this.makerData.forEach(o=>{
                        if(x.repairFeeId === o.repairFeeId) x.makerArr = o;
                      })
                    if(x.makerArr === undefined) x.makerArr = "";
                  })
                this.detailData = this.tempData;
              })
          }).finally(() => {
            this.$store.commit('finish');
            this.createColumnDefs();
          });
    },
    getNumberFormat(val) {
      if(val){

        if(typeof val === "string"){
          val = val.replace(/[^0-9]/g, "")
        }

        return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    updateMakerItem(pVal){

      const vm = this;
      const rowNode = this.gridApiDetail.getRowNode(this.rowId);

      this.$modal.open({
        component: MakerModal,
        parent: this,
        width: 700,
        props: {
          data: {
          }
        },
        events: {
          close(object) {
            let makerArr  = [];
            object.forEach(x=>{
              makerArr.push({
                makerId:x.makerId,
                makerNm:x.makerNm
              })
            })
            vm.detailData[vm.rowId].makerArr = makerArr;
            rowNode.setDataValue('makerStr', vm.makerStr(makerArr));
          }
        }
      });
    },
    updateItem(params){

      if(params.repairFee1 == ""){
        this.$swal({type: 'warning', text: '내근료는 필수 입력 사항입니다.'});
        return false;
      }else if(params.repairFee2 == ""){
        this.$swal({type: 'warning', text: '외근료는 필수 입력 사항입니다.'});
        return false;
      }

      console.log('params    ',params);

      this.$store.commit('loading')
      this.$http
          .put('/api/obstacleTreatMng/update',{
            companyId: this.$store.state.loginInfo.compCd,
            repairFeeId:params.repairFeeId,
            repairCatId:params.catId,
            startDt:params.startDt,
            repairFee1:params.repairFee1,
            repairFee2:params.repairFee2,
            repairFee3:params.repairFee3,
            repairFee4:params.repairFee4,
            repairFee5:params.repairFee5,
            repairFee6:params.repairFee6,
            repairFee7:params.repairFee7,
            repairFee8:params.repairFee8,
            repairFee9:params.repairFee9,
            repairFee10:params.repairFee10,
            updatorId: this.$store.state.loginInfo.id,
            processTime: "",
            makerList : this.isEmpty(params.makerArr) == "" ? [] : params.makerArr
          })
          .then(response => {
            this.$swal({ type: 'success', text: '수정되었습니다.' });
            this.goOpen();
            this.subGoOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    getDateFormat(val) {
      if (val) {
        return this.isEmpty(val) == '' ? '' : this.$moment(val).format('YYYY-MM-DD');
      }
    },
    isEmpty(value){
      if( value == "" || value == null || value == 'null' || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    makerStr(param){
      if (typeof param === 'string') return param;

      let makerStr = "";
      param.forEach((x,i)=>{
        if(i == 0){
          makerStr = x.makerNm;
        }else{
          makerStr += ',' + x.makerNm;
        }
      })
      return makerStr;
    },
    goOpen() {

      this.cancel();
      const voRow = this.rowData //선택된 Row
      this.catDetail = this.defForm;
      this.parentNm = voRow.menu_nm;
      this.$store.commit('loading')
      this.$http
          .post("/api/obstacleTreatMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow.menu_id,
            standDt : this.form.startDt,
            catNm4: "",
            catNm5: "",
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.detailData = [];
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    subGoOpen(){
      this.cancel();
      const voRow = this.subRowData;
      this.$store.commit('loading')
      this.$http
          .post("/api/obstacleTreatMng/detail/sub", {
            companyId: this.$store.state.loginInfo.compCd,
            catId: voRow.catId,
            sortType : true,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              // this.detailData = response.data

              this.catDetail = voRow;

              this.$refs.obstacleInfo.form.catId = voRow.catId;
              this.tempData = response.data
              let submitList = [];
              response.data.forEach(x=>{
                submitList.push({
                  companyId: this.$store.state.loginInfo.compCd,
                  repairFeeId: x.repairFeeId
                })
              });

              this.$http.post("/api/obstacleTreatMng/detail/sub/maker",submitList).then(response =>{

                this.makerData = response.data;
                this.makerData.forEach(x=>{
                  if(x[0] !== undefined){
                    x.repairFeeId = x[0].repairFeeId;
                  }
                })
                this.tempData.forEach(x=>{
                  this.makerData.forEach(o=>{
                    if(x.repairFeeId === o.repairFeeId) x.makerArr = o;
                  })
                  if(x.makerArr === undefined) x.makerArr = "";
                })
                this.detailData = this.tempData;
              })

            }
          }).finally(() => {
        this.$store.commit('finish');
        this.createColumnDefs();
      });
    },
    save() {
      const catInfo = JSON.parse(JSON.stringify(this.$refs.obstacleInfo.form));
      const voRow = this.subRowData;
      if(!this.gridRequireCheck([this.$refs.gridMain, this.$refs.gridSub ])) return;

      if(!voRow){
        this.$swal({type: 'warning', text: '제품을 선택 하여 주세요.'});
        return false;
      }else
      if(catInfo.repairFee1 == ""){
        this.$swal({type: 'warning', text: '내근료는 필수 입력 사항입니다.'});
        return false;
      }else if(catInfo.repairFee2 == ""){
        this.$swal({type: 'warning', text: '외근료는 필수 입력 사항입니다.'});
        return false;
      }


      const makers = this.isEmpty(catInfo.makers) == "" ? [] : catInfo.makers; // 제조사
      //저장 시작
      this.$http
        .put('/api/obstacleTreatMng/save',{
          companyId: this.$store.state.loginInfo.compCd,
          // repairFeeId:0,
          repairCatId:voRow.catId,
          startDt:catInfo.startDt,
          repairFee1:catInfo.repairFee1,
          repairFee2:catInfo.repairFee2,
          repairFee3:catInfo.repairFee3,
          repairFee4:catInfo.repairFee4,
          repairFee5:catInfo.repairFee5,
          repairFee6:catInfo.repairFee6,
          repairFee7:catInfo.repairFee7,
          repairFee8:catInfo.repairFee8,
          repairFee9:catInfo.repairFee9,
          repairFee10:catInfo.repairFee10,
          creatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
          processTime: "",
          makerList : makers
        })
        .then(response => {
          this.$swal({ type: 'success', text: '저장되었습니다.' });
          this.goOpen();
          this.subGoOpen();
        })
        .catch(({ message }) => {
          if (message === "Request failed with status code 500") {
            this.$swal({ type: "error", html: "오류가 발생했습니다. <br> 적용일자를 확인해주세요." });
          }
        });


  // }

    },
    deleteRow() {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0)this.$swal({ type: 'error', text: '삭제할 분류를 체크하세요.' });

      for (var i = 0; chkDatas.length > i ; i++){
        let catId = parseInt(chkDatas[i].catId);
        let updatorId = this.$store.state.loginInfo.loginId; // 추후 로그인 id 받아서 처리
        let compCd =  this.$store.state.loginInfo.compCd;
        this.$http.delete(_url("/api/obstacleTreatMng/delete/"+ (compCd) +"/"+ (catId) + "/" + (updatorId) ), {
          process_time : new Date()
        }).then(response => {
          this.$swal({ type: 'success', text: '삭제 되었습니다.' });
          this.goOpen();
        });
      }


    },
    addRow() {
      this.data.push({
        groupCd: "",
        groupNm: "",
        useYn: "Y",
        groupDesc: "",
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {
      try{

        const row = this.gridApiSub.getSelectedNodes()

        if(row.length < 1)
          throw '선택된 행이 없습니다.'

        let index = row[0].rowIndex
        this.subData.splice(index, 1)

      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      try{

        const row = this.gridApiSub.getSelectedNodes()
        if(row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row[0].rowIndex;
        const data = row[0].data;

        this.detailData.push(data);

        // this.detailData.push({
        // catId:"",
        // catIdx:"",
        // catKey:"",
        // catLvl:"",
        // catNm:"",
        // catPath:"",
        // catValue1:"",
        // catValue2:"",
        // catValue3:"",
        // catValue4:"",
        // catValue5:"",
        // companyId:"",
        // createDt:"",
        // creatorId:"",
        // creatorNm:"",
        // deleteYn:"N",
        // description:"",
        // endDt:"",
        // keyPath:"",
        // parentId:"",
        // repairCatId:"",
        // repairFee1:"",
        // repairFee2:"",
        // repairFee3:"",
        // repairFee4:"",
        // repairFee5:"",
        // repairFee6:"",
        // repairFee7:"",
        // repairFee8:"",
        // repairFee9:"",
        // repairFee10:"",
        // repairFeeId:"",
        // sortPath:"",
        // startDt:"",
        // topKey:"RepairCat",
        // updateDt:"",
        // updatorId:"",
        // updatorNm:"",
        // useYn: "Y",
        // });
      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    cancel(){
      // CatInfo 초기화
      this.$refs.obstacleInfo.form = _.clone(this.defForm);
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      datePicker: DatepickerCellRenderer,
      checkboxRenderer: CheckboxCellRenderer,
      schBtn : AgGridSearchBtn,
      buttonCellRenderer: ButtonCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>
